import { DeseretBook } from '@deseretbook/dbcom-sdk'

export default new DeseretBook({
  host: window.location.origin,
  headers: {
    'X-Spree-Token': Cookies.get('X-SPREE-TOKEN'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})
